import spartaGlobalParams from '@sparta.global.utilities/sparta-global-params-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { button } from '@sparta.global.helpers/button-helper/dist/es6.js';
import { requiredAttrsCheck, extend, removeReservedAttrs, combineAttrs, buildAttrsString } from '@sparta.global.helpers/utils-helper/dist/es6.js';

/**
 * Handlebars Path Helpers
 * Copyright (c) 2013 Jon Schlinkert, Brian Woodward, contributors
 * Licensed under the MIT License (MIT).
 */

/**
 * An object literal wrapper for the Checkbox Helper.
 * @constant {object}
 */
function checkbox(data, args) {
  const globalStrings = spartaGlobalParams.getSpaParams({
    context: args,
    lookupKey: 'inputCheckbox',
    defaultObj: {
      selectAll: 'Select all',
      unSelectAll: 'Unselect all'
    }
  });
  const requiredAttrs = ['id'];
  const reservedAttrs = ['type', 'data-mask', 'data-gis-mask'];
  const combinableAttrs = {
    class: 'spa-input-option spa-input-option--checkbox',
    value: ''
  };
  const cbCount = data.checkboxes.length;
  const errorId = cbCount === 1 ? data.checkboxes[0].checkbox.attrs.id : data.id;
  const dataHelpToggle = data.helpToggle ? data.helpToggle : data.label;
  const dataADAHiddenLabel = data.adaHiddenLabel ? data.adaHiddenLabel : false;
  const checkUncheckAllLink = data && data.checkUncheckAllControl || 'auto';

  // Regular expression to strip HTML tags in case markup gets inserted into a label text value.
  const htmlToStrip = /<\/?[^>]+(>|$)/g;

  // Generates markup for a "required" span if one is needed.
  const inputLabelRequiredSpan = required => {
    if (required) {
      return '<span class="spa-input-label--asterisk">&nbsp;*</span>';
    }
    return '';

    /* Save me in case this gets used again.
    const optionalText = '<span class="spa-input-label__optional-text">optional</span>';
    return `
      <span class="spa-input-label--required">
        <span aria-hidden="true">(</span>${optionalText}<span aria-hidden="true">)</span>
      </span>
    `;
    */
  };

  // if checkbox group, check if any are requried so that group gets proper flag.
  let groupRequired = false;
  for (let ab = 0; ab < cbCount; ab += 1) {
    const getData = data.checkboxes[ab];
    if (getData) {
      const getRequired = getData.required;
      if (getRequired) {
        groupRequired = true;
        break;
      }
    }
  }
  let cbGroup = '';
  for (let i = 0; i < cbCount; i += 1) {
    const cbData = data.checkboxes[i];
    if (!cbData) {
      throw new Error('No data found.');
    }
    const attrsId = cbData.checkbox.attrs.id;
    const labelText = cbData.label.text;
    const cbRequired = cbData.required;
    cbData.asterisk;
    const helpToggle = cbData.helpToggle ? cbData.helpToggle : cbData.label.text;
    if (!requiredAttrsCheck(cbData.checkbox.attrs, requiredAttrs).pass) {
      throw new Error(`You are missing the required attribute ${requiredAttrsCheck(cbData.checkbox.attrs, requiredAttrs).missingField}`);
    }
    const attrGroup = {};
    extend({}, attrGroup, cbData.checkbox.attrs);
    removeReservedAttrs(attrGroup, reservedAttrs);
    combineAttrs(attrGroup, combinableAttrs);
    const cbAttrs = buildAttrsString(attrGroup);
    let cbWrapper = `<div class="spa-input-options-wrapper${cbData.checkbox.attrs['data-help-body'] ? ' has-help' : ''}" ${cbData.checkbox.conditionalContent ? `data-option-has-conditional-content data-conditional-content="${cbData.checkbox.conditionalContent}"` : ''}>`;
    const cbHtml = `<input type="checkbox" 
      aria-describedby="${errorId}_errorMessage ${cbData.checkbox.attrs.id}-hint-text" ${cbAttrs}${data.vueOptionsStr || ''}${data.name ? `name="${data.name}"` : ''}${cbData.required || data.required ? `required aria-required="true" 
        ${typeof cbData.required === 'string' ? `data-required-error-message="${cbData.required}"` : ''}` : ''}${cbData.disabled || data.disabled ? 'disabled aria-disabled="true"' : ''} /><span class="spa-input-check">&nbsp;</span>`;
    let cbLabel = `<label class="spa-input-option-label" for="${attrsId}">${labelText}&#8288;<span class='ada-hidden'>${cbData.label.adaText ? cbData.label.adaText : ''}</span>${!groupRequired || cbCount === 1 ? `&#8288;${inputLabelRequiredSpan(cbRequired)}` : ''}
  </label>`;
    if (cbData.checkbox.attrs['data-help-body']) {
      // Add a help pop-up trigger, either a question mark or some link text.
      const triggerText = cbData.checkbox.attrs['data-help-link'] || '';
      const triggerClass = triggerText ? 'toggle-trigger-link' : 'toggle-trigger svg-button';
      const cbHelpTrigger = button({
        content: triggerText || '&nbsp;',
        classes: `${triggerClass} spa-btn--link`,
        attributes: {
          id: `help-open-${cbData.checkbox.attrs.id}`,
          "aria-label": helpToggle.replace(htmlToStrip, '').replace(/"/g, '&quot;')
        }
      });
      let cbHelpContainer = `<div class="input-help" id="helpLayer_${cbData.checkbox.attrs.id}" role="tooltip" aria-hidden="true">`;
      const cbHelpClose = button({
        content: '&nbsp;',
        classes: 'close-trigger svg-button',
        attributes: {
          id: `help-close-${cbData.checkbox.attrs.id}`,
          "aria-label": helpToggle.replace(htmlToStrip, '').replace(/"/g, '&quot;')
        }
      });
      let cbHelpBody = `<div class="body">${cbData.checkbox.attrs['data-help-body']}</div>`;
      if (cbData.checkbox.attrs['data-help-head']) {
        // New HELIX Requirement
        // --------------------------
        // cbHelpBody = `<div class="head" data-font="cnx-bold">${
        cbHelpBody = `<div class="head">${cbData.checkbox.attrs['data-help-head']}</div>${cbHelpBody}`;
        // --------------------------
      }
      cbHelpContainer += `${cbHelpClose}${cbHelpBody}</div>`;
      cbWrapper += `${cbHtml}${cbLabel}${cbHelpTrigger}${cbHelpContainer}</div>`;
    } else {
      cbWrapper += `${cbHtml}${cbLabel}</div>`;
    }
    cbGroup += cbWrapper;
  }
  let cbGroupContainer = `<div class="spa-input spa-input-options spa-input--${data.skin ? data.skin : 'sparta2'} ${data.darkBackground ? 'spa-input-options--inverse' : ''} ${data.containerClasses ? `${data.containerClasses.join(' ')}` : ''}">`;
  const cbGroupWrapper = `<div class='spa-input-options-list spa-input-options-list--${data.direction || 'vertical'}'>${cbGroup}${data.direction ? '<div class="horizontal-clear"></div>' : ''}</div>`;
  const cbGroupHint = `<p id="${data.id}-hint-text" class="spa-input-options-hint">${data.hintText ? data.hintText : ''}</p>`;
  const cbGroupError = `<div id="${errorId}_errorMessage" class="spa-input-error-message spa-icon--error" aria-hidden="true"></div>`;
  let checkboxControls = '';
  // If the checkbox is configured with visible check/uncheck all links, add them after
  if (checkUncheckAllLink === 'visible') {
    const checkboxClass = 'checkbox-control spa-btn spa-btn--link';
    const groupLinkWrapper = `<div class="checkbox-control-wrapper">`;
    const checkAllLink = button({
      content: `${globalStrings.selectAll}`,
      classes: `${checkboxClass} checkbox-check-all-link`
    });
    const linkDivider = '<span class="checkbox-link-divider"> | </span>';
    const unCheckAllLink = button({
      content: `${globalStrings.unSelectAll}`,
      classes: `${checkboxClass} checkbox-uncheck-all-link`
    });
    checkboxControls += `${groupLinkWrapper}${checkAllLink}${linkDivider}${unCheckAllLink}</div>`;
  }
  if (cbCount > 1 || data.allowSingleCheckboxGroup) {
    // Add a help pop-up trigger, either a question mark or some link text.
    const triggerText = data['data-help-link'] || '';
    const helpText = data['data-help-body'] || '';
    const clearfixClass = helpText && !triggerText ? 'clearfix' : '';
    const inlineTriggerClass = helpText && !triggerText ? 'inline-legend-icon' : '';
    const groupErrorMsg = 'required' in data && typeof data.required === 'string' ? `data-required-error-message="${data.required}"` : '';
    const validationRules = data.validationRules ? `data-validation-rules='${JSON.stringify(data.validationRules).replace(/'/g, '&#39;')}'` : '';
    let cbGroupFieldset = `<fieldset class="spa-fieldset ${clearfixClass}" aria-describedby="${errorId}_errorMessage ${data.id}-hint-text" id="${data.id}" aria-invalid="false" ${validationRules} ${groupErrorMsg}>`;
    const cbGroupFieldsetLabel = `<legend class="spa-fieldset-label ${inlineTriggerClass}" for="${data.id}" aria-hidden="${dataADAHiddenLabel}">${data.label}${groupRequired || data.required ? inputLabelRequiredSpan(true, data.asterisk) : ''}<span class='ada-hidden'>${data.adaText ? data.adaText : ''}</span>` + '</legend>';
    if (data['data-help-body']) {
      const triggerClass = triggerText ? 'toggle-trigger-link' : 'toggle-trigger svg-button';
      const cbGroupHelpTrigger = `<button id="help-open-${data.id}" type="button" aria-label="${dataHelpToggle.replace(htmlToStrip, '').replace(/"/g, '&quot;')}" class="${triggerClass} spa-btn spa-btn--link">${triggerText || '&nbsp;'}</button>`;
      let cbGroupHelpContainer = `<div class="input-help" id="helpLayer_${data.id}" role="tooltip" aria-hidden="true">`;
      const cbGroupHelpClose = `<button id="help-close-${data.id}" type="button" aria-label="${dataHelpToggle.replace(htmlToStrip, '').replace(/"/g, '&quot;')}" class="close-trigger svg-button">&nbsp;</button>`;
      let cbGroupHelpBody = `<div class="body">${data['data-help-body']}</div>`;
      if (data['data-help-head']) {
        cbGroupHelpBody = `<div class="head" data-font="cnx-bold">${data['data-help-head']}</div>${cbGroupHelpBody}`;
      }
      cbGroupHelpContainer += `${cbGroupHelpClose}${cbGroupHelpBody}</div>`;
      cbGroupFieldset += `${cbGroupFieldsetLabel}${cbGroupHelpTrigger}${cbGroupHelpContainer}${checkboxControls}${cbGroupWrapper}${cbGroupHint}${cbGroupError}</fieldset>`;
    } else {
      cbGroupFieldset += `${cbGroupFieldsetLabel}${checkboxControls}${cbGroupWrapper}${cbGroupHint}${cbGroupError}</fieldset>`;
    }
    cbGroupContainer += `${cbGroupFieldset}</div>`;
  } else {
    cbGroupContainer += `${cbGroupWrapper}${cbGroupError}</div>`;
  }
  return new Handlebars.SafeString(cbGroupContainer);
}
checkbox.functionName = "checkbox";

export { checkbox };
